/* this file is transformed by vux-loader */
/* eslint-disable */
import { get, post } from "../utils/request";

var plugin = function plugin(Vue) {
  Vue.prototype.$get = Vue.$get = function () {
    return get.apply(void 0, arguments);
  };

  Vue.prototype.$post = Vue.$post = function () {
    return post.apply(void 0, arguments);
  };
};

export default plugin;